import ApiService from "@/service/ApiService";

export default function useLogin() {
  const CheckUser = async (id) => {
    ApiService.setHeader();
    return await ApiService.get("scx/check_register_student/" + id);
  };

  return {
    CheckUser,
  };
}
